import { render } from "./credencialesComponent.vue?vue&type=template&id=55fc424a"
import script from "./credencialesComponent.vue?vue&type=script&lang=js"
export * from "./credencialesComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sendi\\.tools\\sources\\SendiNewClient2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__